"use client";

import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconTag, IconX } from "@tabler/icons-react";
import { Badge } from "@/components/ui/badge";
import { getPromoCodeErrorMessage } from "@/lib/promo-code-error";
import { useRemoveCoupon } from "@/mutations/useRemoveCoupon";
import { useCart } from "@/queries/useCart";
export function PromoCodeApplied() {
  const $ = _c(21);
  const {
    data: cart
  } = useCart();
  const removeCoupon = useRemoveCoupon();
  if (!cart?.couponCode) {
    return null;
  }
  const discountTotal = cart.pricing.couponDiscountTotal;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconTag size={12} className="shrink-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== cart.couponCode) {
    t1 = <span>{cart.couponCode}</span>;
    $[1] = cart.couponCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== discountTotal) {
    t2 = discountTotal > 0 && <span className="text-green-600">{`-${CurrencyFormatter.formatUSD(discountTotal)}`}</span>;
    $[3] = discountTotal;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = removeCoupon.isPending || undefined;
  let t4;
  if ($[5] !== removeCoupon) {
    t4 = () => removeCoupon.mutate();
    $[5] = removeCoupon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconX size={12} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== removeCoupon.isPending || $[9] !== t3 || $[10] !== t4) {
    t6 = <button type="button" aria-label="Remove promo code" aria-busy={t3} disabled={removeCoupon.isPending} onClick={t4} className="focus-visible:ring-ring/50 -mr-1 ml-0.5 flex size-6 shrink-0 items-center justify-center rounded-full border border-transparent transition-colors hover:border-neutral-300 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-transparent">{t5}</button>;
    $[8] = removeCoupon.isPending;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t6) {
    t7 = <Badge variant="outline" className="gap-1.5 px-2 py-1 text-sm uppercase transition-colors has-[button:hover:not(:disabled)]:bg-neutral-100">{t0}{t1}{t2}{t6}</Badge>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== cart.couponFailureReason) {
    t8 = cart.couponFailureReason && <p className="pt-1 text-xs text-neutral-500">{getPromoCodeErrorMessage(cart.couponFailureReason)}</p>;
    $[16] = cart.couponFailureReason;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}